import { SchoolReportStudentsUIProvider } from "./SchoolReportStudentsUIContext";
import { SchoolReportStudentsCard } from "./SchoolReportStudentsCard";

export function SchoolReportStudentsPage({
  reportId,
  term,
  goNext
}) {
  return (
    <SchoolReportStudentsUIProvider term={term}>
      <SchoolReportStudentsCard
        reportId={reportId}
        goNext={goNext}
      />
    </SchoolReportStudentsUIProvider>
 );
}